import { gql } from '@apollo/client';

export const CREATE_DOCTOR_ADVICE = gql`
  mutation CreateDoctorAdvice($input: DoctorAdviceCreateInput!) {
    createDoctorAdvice(input: $input) {
      id
      title
      postContent
      thumbnailURL
      videoLink
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_DOCTOR_ADVICE = gql`
  mutation UpdateDoctorAdvice($updateDoctorAdviceId: ID!, $input: DoctorAdviceUpdateInput!) {
    updateDoctorAdvice(id: $updateDoctorAdviceId, input: $input) {
      id
      title
      postContent
      thumbnailURL
      videoLink
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_DOCTOR_ADVICE = gql`
  mutation DeleteDoctorAdvice($deleteDoctorAdviceId: ID!) {
    deleteDoctorAdvice(id: $deleteDoctorAdviceId)
  }
`;

export const GET_ALL_DOCTOR_ADVICES = gql`
  query GetAllDoctorAdvices {
    getAllDoctorAdvices {
      id
      title
      postContent
      thumbnailURL
      videoLink
      createdAt
      updatedAt
    }
  }
`;
